export default "__VITE_ASSET__CiZ1whde__"